import {Component, computed, inject, viewChildren} from '@angular/core'
import {IWaitComponentData, WaitComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {MatButton} from '@angular/material/button'
import {DataService} from '../../../services/data-service'
import {catchError, concat, filter, NEVER, of, switchMap, tap} from 'rxjs'
import {MatDialog} from '@angular/material/dialog'
import {GetName} from '../get-name/get-name'
import {getItem, GUIDE_PATH, HOME_PATH} from '../../../0-application/shared'
import {IOwner} from '../../../0-application/types'
import {verify} from '@sparbanken-syd/personnummer'
import {Router} from '@angular/router'
import {NewCaseIdList} from './new-case-id-list/new-case-id-list'

export interface INewOwner {
  sub: string
  name: string
  org: boolean
}

@Component({
  selector: 'spb-new-case',
  imports: [
    MatButton,
    NewCaseIdList
  ],
  templateUrl: './new-case.html',
  styleUrl: './new-case.scss'
})
export class NewCase {

  public lists = viewChildren(NewCaseIdList)

  public invalid = computed(() => {
    return this.lists()[0].ownerForm().invalid()
  })

  public searchIgDisabled = computed(() => {
    return this.invalid() && (!(this.lists()[1].owners()[0].sub) || this.lists()[1].ownerForm().invalid())
  })

  private readonly service = inject(DataService)

  private readonly dialog = inject(MatDialog)

  private readonly router = inject(Router)


  public start() {


    const item = getItem(verify(this.lists()[0].owners()[0].sub)[12])
    item.accounts = 'v2'
    item.collections.owners = []


    const ref = this.dialog.open(WaitComponent, {
      data: {
        title: 'Söker',
        text: 'Söker efter kunder'
      },
      disableClose: true
    })

    const customers = this.lists()
      .flatMap(c => c.ownerForm().value())
      .filter(o => o.sub)


    const observables = customers.map(o => {
        return this.service.checkOwner(verify(o.sub)[12])
          .pipe(
            switchMap(r => {
              if (r?.name) {
                o.name = r.name
                o.sub = verify(r.sub)[12]
                return of(o)
              }
              return this.dialog.open<GetName, IOwner, INewOwner>(GetName, {data: o}).afterClosed()
            }),
            filter(Boolean), // Only to satisfy TS, we know it is always the owner.
            tap(l => {
              if (l.org) {
                item.orgs.push({sub: l.sub, name: l.name})
              } else {
                item.collections.owners!.push({sub: l.sub, name: l.name})
              }
            })
          )
      }
    )
    const create = this.service.create(item)
    concat(...observables, create)
      .subscribe({
          // When all concat:ed then navigate
          complete: () => {
            ref.close()
            this.router.navigate(['/', HOME_PATH, GUIDE_PATH, this.service.current()!.id, 0]).then()
          }
        }
      )
  }

  public search() {

    // A list of all personnummers already added.
    const customers = new Set(this.lists()
      .flatMap(c => c.ownerForm().value())
      .filter(o => o.sub)
      .map(o => verify(o.sub)[12]))

    this.dialog.open(WaitComponent, {
      data: {
        title: 'Söker',
        text: `Söker efter intressegemenskap för ${[...customers].join(', ')}. ` +
          `Det tar ca ${customers.size * 2.5} sekunder.`
      },
      disableClose: true
    })
    this.service.getCommunity([...customers.values()])
      .pipe(catchError(() => {
          this.dialog.closeAll()
          this.dialog.open<WaitComponent, IWaitComponentData, void>(WaitComponent, {
            data: {
              title: 'Fel',
              text: 'Hämtningen misslyckades, beror oftast på att EDW är långsamt.',
              closable: true
            }
          })
          return NEVER
        })
      )
      .subscribe(res => {
        res.forEach(c => {
          if (!customers.has(c.sub)) {
            this.lists()[verify(c.sub).isOrg ? 1 : 0].add(c.sub, c.name)
          }
        })
        this.dialog.closeAll()
      })
  }
}
